/**
 * BuildUrl
 *
 * Module that builds both the search and interu
 *
 * @return {object}
 */

OT.createNS('OT.Search.Requests.BuildUrl');

OT.Search.Requests.BuildUrl = (function () {

    var apiRoute = '/s/node/api';

    var setApiRoute = function (pathName, route) {
        var culture = getCultureUrlSegment(pathName);

        apiRoute = '/s' + culture + route;
    };

    var getCultureUrlSegment = function (pathName) {
        var cultureRegEx = /\/([a-z]{2}-[a-zA-Z]{2})\//;

        var match = cultureRegEx.exec(pathName);

        if (match === null) {
            return '';
        }

        if (match[1] === undefined) {
            return '';
        }

        return '/' + match[1];
    };

    var buildSearchString = function (obj) {
        obj = obj || OT.Search.Params.getAll();

        if (
            (obj.neighborhoodids && obj.neighborhoodids.length > 0) ||
            (obj.regionids && obj.regionids.length > 0)
        ) {
            delete obj.distance;
            delete obj.latitude;
            delete obj.longitude;
        }

        var originalTermFromQuery = OT.Search.Data.get().Display.OriginalTermFromQuery

        if (OT.Search.Data.get().Experiments.sfx545 && originalTermFromQuery) {
            obj.originalTerm = originalTermFromQuery;
        }

        if (_.isArray(obj)) {
            throw new Error('BuildUrl: incompatible parameters format');
        } else if (_.isEmpty(obj)) {
            throw new Error('BuildUrl: parameters not provided');
        }

        return $.param(obj);
    };

    var buildUrl = function (obj, url) {
        var query = buildSearchString(obj);
        return url + '?' + query;
    };

    var getApiParams = function () {
        var params = _.clone(OT.Search.Params.getAll());

        if (params.PageType === undefined) {
            params['PageType'] = OT.Search.Data.get().Request.PageType;
        }

        return params;
    };

    return {
        setApiRoute: setApiRoute,
        api: function (obj, url) {
            var params = _.extend(getApiParams(), obj);
            return buildUrl(params, url || apiRoute);
        },
        dinerschoice: function (obj, url) {
            return buildUrl(obj, url || '/s/dinerschoice');
        },
        interim: function (obj, url) {
            return buildUrl(obj, url || '/s/interim');
        },
        queryString: function (obj) {
            return buildUrl(obj, '');
        },
        searchresults: function (obj, url) {
            return buildUrl(obj, url || '/s/node/api');
        }
    };

})();
